
export type State = {
  cameraPos: number
}

export const state: State = {
  cameraPos: 0
};
